<template>
  <div class="news-page" ref="newsPage">
    <section id="news" class="news">
      <h2>{{ $t('navigation.news') }}</h2>
      <div class="container">
        <loader v-if="!newsPage.length" />
        <div v-if="newsPage.length">
          <article v-for="n in newsPage" :key="n.date">
          <div class="title">
            <div class="icon"></div>
            <div class="content">
              <h4>
                <time>{{n.date}}</time>
                {{ $t('news.item title') }}
              </h4>
            </div>
          </div>
          <div class="cashier" v-if="n.sections['cashier']">
            <div class="icon"></div>
            <div class="content">
              <div class="name">{{ $t('news.cashier') }}</div>
              <ul>
                <li v-for="item in n.sections['cashier']">{{item.body}}</li>
              </ul>
            </div>
          </div>
          <div class="monitor" v-if="n.sections['monitor']">
            <div class="icon"></div>
            <div class="content">
              <div class="name">{{ $t('news.monitor') }}</div>
              <ul>
                <li v-for="section in n.sections['monitor']">{{section.body}}</li>
              </ul>
            </div>
          </div>
          <div class="agent" v-if="n.sections['agent']">
            <div class="icon"></div>
            <div class="content">
              <div class="name">{{ $t('news.agent') }}</div>
              <ul>
                <li v-for="section in n.sections['agent']">{{section.body}}</li>
              </ul>
            </div>
          </div>
          <div class="terminal" v-if="n.sections['terminal']">
            <div class="icon"></div>
            <div class="content">
              <div class="name">{{ $t('news.terminal') }}</div>
              <ul>
                <li v-for="section in n.sections['terminal']">{{section.body}}</li>
              </ul>
            </div>
          </div>
          <div class="online" v-if="n.sections['online']">
            <div class="icon"></div>
            <div class="content">
              <div class="name">{{ $t('news.online') }}</div>
              <ul>
                <li v-for="section in n.sections['online']">{{section.body}}</li>
              </ul>
            </div>
          </div>
        </article>

        <div class="paginator">
          <paginate
            v-model="page"
            :pageCount="pageCount"
            :prev-link-class="'prev icon-navigate_before'"
            :next-link-class="'next icon-navigate_next'"
            :prevText="''"
            :nextText="''"
            :click-handler="pageClick"
          ></paginate>
        </div>
      </div>
      </div>
    </section>
    <contacts />
  </div>
</template>

<script>
import { newsService } from "../services/news.service.js";
import Contacts from "../components/contacts.vue";
import Loader from "../components/loader.vue";

const maping = {
  // ru
  агент: "agent",
  устройства: "terminal",
  кассир: "cashier",
  монитор: "monitor",
  онлайн: "online",
  // fr
  caissier:"cashier",
  agent: "agent",
  dispositifs: "terminal",
  moniteur: "monitor",
  "en ligne": "online",
  // en
  "agent":"agent",
  "devices":"terminal",
  "cashier":"cashier",
  "monitor":"monitor",
  "online":"online",
  //es
  "agente":"agent",
  "dispositivos":"terminal",
  "cajero":"cashier",
  "monitorear":"monitor",
  "en linea":"online",
};

function getTag(msg) {
  return msg.substr(0, msg.indexOf(":"));
}

function mapTag(tag) {
  return maping[tag.toLowerCase()];
}

function trim(msg) {
  return msg.replace(/^[\s\uFEFF\xA0\:]+|[\s\uFEFF\xA0\:]+$/g, "");
}

export default {
  name: "NewsPage",
  components: { Contacts, Loader },
  data() {
    return {
      news: [],
      page: 1,
      newsPerPage: 5,
      languages: ["en", "es", "fr"],
      //language: "en"
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.news.length / this.newsPerPage) - 1;
    },
    newsPage() {
        return this.news.slice((this.page-1) * this.newsPerPage, this.page * this.newsPerPage + this.newsPerPage)
    },
    language(){
            return this.$i18n.locale;
    }
  },
  async mounted() {
    
    this.news = await this.getNews(this.language);
  },
  watch:{
    async language(){
      this.page = 1;
      this.news = await this.getNews(this.language);
    }
  },
  methods:{
      pageClick(page){
           
          setTimeout(() => {
            window.scrollTo({ 
                top: this.$refs.newsPage, 
                behavior: 'smooth' 
              })
          })
      },
      async getNews(lang = "en"){
        if (this.languages.indexOf(lang) == -1) return;

          const response = await newsService.getNews(this.language) || [];

          return response.map(n => ({
            title: n.title,
            tags: n.tags,
            date: new Date(n.date).toLocaleDateString(),
            sections: n.body
              .split("*")
              .filter(m => m)
              .map(m => {
                const tag = getTag(m);
                const body = m.replace(tag, "");
                return {
                  tag: mapTag(trim(tag)),
                  body: trim(body)
                };
              })
              .reduce((result, msg) => {
                result[msg.tag] = result[msg.tag] || [];
                result[msg.tag].push(msg);
                return result;
              }, {})
          }));   
      }
  }
};
</script>

<style lang="scss" scoped>
.news-page {
  flex: 1 1 auto;

  .news {

    h2 {
      font-size: 6rem;
      font-weight: 300;
      text-align: center;
      text-transform: uppercase;
      margin: $spacer * 4 0;
    }
    article {
      position: relative;
      display: block;
      background: $white;
      box-shadow: 0 5px 10px rgba($black, 0.3);
      margin-bottom: $spacer * 2;

      > div {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
      }

      .icon {
        position: relative;
        width: 64px;
        min-height: 64px;
        background-color: #4c4c4c;
        flex: 0 0 auto;

        &:before {
          position: absolute;
          top: 16px;
          left: 16px;
          content: "";
          display: block;
          width: 32px;
          height: 32px;
          background-image: url("/assets/news.png");
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        flex: 1 1 auto;
        padding: $spacer;
        font-size: 1.6rem;
        overflow: hidden;

        ul {
          list-style-position: inside;
          padding: 0;
          margin: 0;
        }
      }

      .name {
        font-size: 2rem;
        text-transform: uppercase;
      }

      .title {
        h4 {
          font-size: 2.6rem;
          font-weight: normal;
          text-transform: uppercase;
          color: $black;
          margin: 0;
        }
        time {
          float: right;
          font-size: 2rem;
          font-weight: normal;
          color: $black;
        }
      }

      .cashier {
        .icon {
          background-color: #fec327;

          &:before {
            background-position-x: -32px;
          }
        }
      }

      .monitor {
        .icon {
          background-color: #23b427;

          &:before {
            background-position-x: -64px;
          }
        }
      }

      .agent {
        .icon {
          background-color: #f4522c;

          &:before {
            background-position-x: -96px;
          }
        }
      }

      .online {
        .icon {
          background-color: #802cf4;

          &:before {
            background-position-x: -128px;
          }
        }
      }

      .terminal {
        .icon {
          background-color: #2c7ef4;

          &:before {
            background-position-x: -160px;
          }
        }
      }
    }

    .loader {
        margin-top: 100px;
        margin-bottom: 100px;
    }
  }
  }
</style>
